import FieldConfig from "../../../../proto/field-config";
import Task from "../../../../../model2/task/task";
import FieldDate from "../../../../generic/datetime/date/date";
import {FIELD_CONDITIONS_DATE} from "../../../../conditions/date";

export default class FieldTaskMomentClosed extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon                   = 'i5-date-closed'
        this.label                  = 'Date closed'

        this.canManuallySetValue    = false

        this.groupByNoValueLabel    = "Not closed"

        this.conditionTypes         = FIELD_CONDITIONS_DATE
    }

    canEdit(model:Task):boolean {
        return false
    }
}
